import Vue from 'vue'
import Router from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(Router)

export default new Router({
    mode: 'history',
    // mode: 'hash',
    base: process.env.BASE_URL,
    routes: [
        // {
        //   path: '/',
        //   name: 'home',
        //   component: Home
        // },
        /**
         * 登陆页
         * @jlliang
         */
        {
            path: '/',
            name: 'login',
            component: () => import(/* webpackChunkName: "about" */ '../views/login/login.vue')
        },
        /**
         * 注册页
         * @jlliang
         */
        {
            path: '/userRegister',
            name: 'userRegister',
            component: () => import(/* webpackChunkName: "about" */ '../views/login/userRegister.vue')
        },
        /**
         * 菜单页
         * @jlliang
         */
        {
            path: '/myMenu',
            name: 'myMenu',
            component: () => import(/* webpackChunkName: "about" */ '../views/start/myMenu.vue')
        },
        /**
         * 重点关注车辆
         * @jlliang
         */
        {
            path: '/attentioncar',
            name: 'attentioncar',
            component: () => import(/* webpackChunkName: "about" */ '../views/attentioncar/attentioncar.vue')
        },
        /**
         * 安装订单页
         * @jlliang
         */
        {
            path: '/salesman',
            name: 'salesman',
            component: () => import(/* webpackChunkName: "about" */ '../views/salesman/salesman.vue')
        },
        /**
         * 安装订单页
         * @jlliang
         */
        // {
        //     path: '/resalesman',
        //     name: 'resalesman',
        //     component: () => import(/* webpackChunkName: "about" */ '../views/salesman/resalesman.vue')
        // },
        // {
        //     path: '/orderDetails',
        //     name: 'orderDetails',
        //     component: () => import(/* webpackChunkName: "about" */ '../views/salesman/orderDetails.vue')
        // },
        {
            path: '/usergroupinstallorder',
            name: 'usergroupinstallorder',
            component: () => import(/* webpackChunkName: "about" */ '../views/om/install-order/usergroup-install-order.vue')
        },
        {
            path: '/installorder',
            name: 'installorder',
            component: () => import(/* webpackChunkName: "about" */ '../views/om/install-order/install-order.vue')
        },
        {
            path: '/installorderdetails',
            name: 'installorderdetails',
            component: () => import(/* webpackChunkName: "about" */ '../views/om/install-order/install-order-details.vue')
        },
        {
            path: '/addinstallorder',
            name: 'addinstallorder',
            component: () => import(/* webpackChunkName: "about" */ '../views/om/install-order/components/add-install-order.vue')
        },
        /**
         * 安装员安装订单页面
         * @jlliang
         */
        // {
        //     path: '/setter',
        //     name: 'setter',
        //     component: () => import(/* webpackChunkName: "about" */ '../views/setter/setter.vue')
        // },
        {
            path: '/installerinstallorder',
            name: 'installerinstallorder',
            component: () => import(/* webpackChunkName: "about" */ '../views/om/installer-install-order/installer-install-order.vue')
        },
        {
            path: '/installerinstallorderdetails',
            name: 'installerinstallorderdetails',
            component: () => import(/* webpackChunkName: "about" */ '../views/om/installer-install-order/installer-install-order-details.vue')
        },
        {
            path: '/installerinstallorderconfirm',
            name: 'installerinstallorderconfirm',
            component: () => import(/* webpackChunkName: "about" */ '../views/om/installer-install-order/components/installer-install-order-confirm.vue')
        },
        /**
         * 安装订单上传图片页
         * @jlliang
         */
        {
            path: '/Uploaderimage',
            name: 'Uploaderimage',
            component: () => import(/* webpackChunkName: "about" */ '../views/salesman/Uploaderimage.vue')
        },
        // {
        //     path: '/text-Upladerimage',
        //     name: 'text-Upladerimage',
        //     component: () => import(/* webpackChunkName: "about" */ '../views/salesman/text-Upladerimage.vue')
        // },
        // {
        //     path: '/UploaderInstallOrderImage',
        //     name: 'UploaderInstallOrderImage',
        //     component: () => import(/* webpackChunkName: "about" */ '../views/salesman/UploaderInstallOrderImage.vue')
        // },
        // /**
        //  * 确认安装上传图片页
        //  * @jlliang
        //  */
        // {
        //     path: '/setter-Uploaderimage',
        //     name: 'setter-Uploaderimage',
        //     component: () => import(/* webpackChunkName: "about" */ '../views/setter/setter-Uploaderimage.vue')
        // },
        // /**
        //  * 确认安装详细页
        //  * @jlliang
        //  */
        // {
        //     path: '/setterorderDetails',
        //     name: 'setterorderDetails',
        //     component: () => import(/* webpackChunkName: "about" */ '../views/setter/setterorderDetails.vue')
        // },


        // /**
        //  * 确认安装设置车辆参数
        //  * @jlliang
        //  */
        // {
        //     path: '/setupVehicleParams',
        //     name: 'setupVehicleParams',
        //     component: () => import(/* webpackChunkName: "about" */ '../views/setter/setupVehicleParams.vue')
        // },
        /**
         * 开发服跳转
         * @jlliang
         */
        {
            path: '/jumptodevelop',
            name: 'jumptodevelop',
            component: () => import(/* webpackChunkName: "about" */ '../views/jump-to-develop.vue')
        },
        /**
         * 轨迹完整分析的百度地图
         * @jlliang
         */
        {
            path: '/tracksintegrityanalysiss',
            name: 'tracksintegrityanalysiss',
            component: () => import(/* webpackChunkName: "about" */ '../views/tracksintegrityanalysiss/tracksintegrityanalysiss.vue')
        },
        /**
         * 轨迹完整分析的百度地图
         * @jlliang
         */
        {
            path: '/BDmap',
            name: 'BDmap',
            component: () => import(/* webpackChunkName: "about" */ '../views/tracksintegrityanalysiss/BDmap.vue')
        },
        /**
         * 轨迹完整分析的百度地图2
         * @jlliang
         */
        {
            path: '/BDmap2',
            name: 'BDmap2',
            component: () => import(/* webpackChunkName: "about" */ '../views/tracksintegrityanalysiss/BDmap2.vue')
        },
        /**
         * 轨迹完整分析的腾讯地图
         * @jlliang
         */
        {
            path: '/QQMap',
            name: 'QQMap',
            component: () => import(/* webpackChunkName: "about" */ '../views/tracksintegrityanalysiss/QQMap.vue')
        },
        /**
         * 续费订单
         * @jlliang
         */
        {
            path: '/renewalorders',
            name: 'renewalorders',
            component: () => import(/* webpackChunkName: "about" */ '../views/renewalorders/renewalorders.vue')
        },
        /**
         * 续费订单详细
         * @jlliang
         */
        {
            path: '/renewalordersDetail',
            name: 'renewalordersDetail',
            component: () => import(/* webpackChunkName: "about" */ '../views/renewalorders/renewalordersDetail.vue')
        },
        /**
         * jt80页面
         * @jlliang
         */
        {
            path: '/jt808devices',
            name: 'jt808devices',
            component: () => import(/* webpackChunkName: "about" */ '../views/ddm/jt808-devices.vue')
        },
        /**
         * SIM卡管理
         * @jlliang
         */
        {
            path: '/siminfos',
            name: 'siminfos',
            component: () => import(/* webpackChunkName: "about" */ '../views/im/sim-infos.vue')
        },
        {
            path: '/installersiminfos',
            name: 'installersiminfos',
            component: () => import(/* webpackChunkName: "about" */ '../views/im/installer-sim-infos.vue')
        },
        /**
         * 短信查询
         * @jlliang
         */
        {
            path: '/shortmessages',
            name: 'shortmessages',
            component: () => import(/* webpackChunkName: "about" */ '../views/ddm/short-messages.vue')
        },
        /**
         * 历史数据查询
         * @jlliang
         */
        {
            path: '/locatehistorys',
            name: 'locatehistorys',
            component: () => import(/* webpackChunkName: "about" */ '../views/history/locate-historys.vue')
        },
        /**
         * 维修订单
         * @jlliang
         */
        {
            path: '/maintainOrders',
            name: 'maintainOrders',
            component: () => import(/* webpackChunkName: "about" */ '../views/maintainOrders/maintainOrders.vue')
        },
        /**
         * 维修订单详细页
         * @jlliang
         */
        {
            path: '/maintainOrdersDetail',
            name: 'maintainOrdersDetail',
            component: () => import(/* webpackChunkName: "about" */ '../views/maintainOrders/maintainOrdersDetail.vue')
        },
        /**
         * 维修订单
         * @jlliang
         */
        {
            path: '/installermaintainorder',
            name: 'installermaintainorder',
            component: () => import(/* webpackChunkName: "about" */ '../views/om/installer-maintain-order/installer-maintain-order.vue')
        },
        {
            path: '/installermaintainorderdetails',
            name: 'installermaintainorderdetails',
            component: () => import(/* webpackChunkName: "about" */ '../views/om/installer-maintain-order/installer-maintain-order-details.vue')
        },
        {
            path: '/installermaintainorderconfirm',
            name: 'installermaintainorderconfirm',
            component: () => import(/* webpackChunkName: "about" */ '../views/om/installer-maintain-order/components/installer-maintain-order-confirm.vue')
        },

        /**
         * 维修订单上传图片页
         * @jlliang
         */
        {
            path: '/maintainOrders-Uploaderimage',
            name: 'maintainOrders-Uploaderimage',
            component: () => import(/* webpackChunkName: "about" */ '../views/maintainOrders/maintainOrders-Uploaderimage.vue')
        },
        /**
         * 维修订单上传图片页-vant框架
         * @jlliang
         */
        {
            path: '/maintainOrders-UploaderImage-vant',
            name: 'maintainOrders-UploaderImage-vant',
            component: () => import(/* webpackChunkName: "about" */ '../views/maintainOrders/maintainOrders-UploaderImage-vant.vue')
        },
        /**
         * 售后维修订单
         * @jlliang
         */
        {
            path: '/salesmaintainOrders',
            name: 'salesmaintainOrders',
            component: () => import(/* webpackChunkName: "about" */ '../views/salesmaintainOrders/salesmaintainOrders.vue')
        },
        /**
         * 售后维修订单详细页
         * @jlliang
         */
        {
            path: '/salesmaintainOrdersDetail',
            name: 'salesmaintainOrdersDetail',
            component: () => import(/* webpackChunkName: "about" */ '../views/salesmaintainOrders/salesmaintainOrdersDetail.vue')
        },
        /**
         * 售后维修订单详细页
         * @jlliang
         */
        {
            path: '/vehiclefreeinquire',
            name: 'vehiclefreeinquire',
            meta: {
                hideInMenu: true,
                title: '车辆保险免费资格',
                notCache: true,
                icon: 'md-home'
            },
            component: () => import('@/views/crm/vehicle-free-inquire.vue')
        },
    ]
})
